
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
// import { Github, X } from 'lucide-react';
import { Github, X, Package } from 'lucide-react';


const ProjectModal = ({ project, onClose }) => {
  if (!project) return null;

  return (
    <AnimatePresence>
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black/95 backdrop-blur-sm z-50 overflow-auto"
        onClick={onClose}
      >
        <motion.div 
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          className="relative max-w-4xl mx-auto my-[5vh] p-4 md:p-8 bg-black border-2 border-[#ff00ff] rounded-lg m-4"
          onClick={e => e.stopPropagation()}
        >
          <button 
            onClick={onClose}
            className="absolute top-2 right-2 md:top-4 md:right-4 text-cyan-400 hover:text-[#ff00ff] transition-colors"
          >
            <X size={20} className="md:w-6 md:h-6" />
          </button>

          <h2 className="text-2xl md:text-3xl font-mono text-cyan-400 mb-4 md:mb-6 flex items-center gap-2">
            <span className="text-[#ff00ff]">&gt;</span>
            {project.title}
          </h2>

          <div className="space-y-4 md:space-y-6 font-mono">
            <section>
              <h3 className="text-lg md:text-xl text-[#ff00ff] mb-2"># Description</h3>
              <p className="text-sm md:text-base text-green-500">{project.description}</p>
            </section>

            <section>
              <h3 className="text-lg md:text-xl text-[#ff00ff] mb-2"># Technical Details</h3>
              <ul className="space-y-2">
                {project.details.map((detail, index) => (
                  <li key={index} className="text-sm md:text-base text-green-500 flex items-start gap-2">
                    <span className="text-cyan-400">$</span>
                    {detail}
                  </li>
                ))}
              </ul>
            </section>

            <section>
              <h3 className="text-lg md:text-xl text-[#ff00ff] mb-2"># Challenges</h3>
              <p className="text-sm md:text-base text-green-500">{project.challenges}</p>
            </section>

            <section>
              <h3 className="text-lg md:text-xl text-[#ff00ff] mb-2"># Impact</h3>
              <p className="text-sm md:text-base text-green-500">{project.impact}</p>
            </section>

            {/* {project.githubLink && (
              <a 
                href={project.githubLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 mt-4 md:mt-6 px-4 md:px-6 py-2 md:py-3 
                         border-2 border-cyan-400 text-cyan-400 text-sm md:text-base
                         hover:border-[#ff00ff] hover:text-[#ff00ff]
                         transition-colors duration-300 rounded-lg"
              >
                <Github size={16} className="md:w-5 md:h-5" />
                View Source Code
              </a>
            )} */}

          <div className="flex flex-wrap gap-4 mt-4 md:mt-6">
              {project.githubLink && (
                <a 
                  href={project.githubLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-4 py-2 border-2 border-cyan-400 text-cyan-400 text-sm md:text-base hover:border-[#ff00ff] hover:text-[#ff00ff] transition-colors duration-300 rounded-lg"
                >
                  <Github size={16} className="md:w-5 md:h-5" />
                  View Source Code
                </a>
              )}
{/*               {project.website && (
                <a 
                  href={project.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-4 py-2 border-2 border-cyan-400 text-cyan-400 text-sm md:text-base hover:border-[#ff00ff] hover:text-[#ff00ff] transition-colors duration-300 rounded-lg"
                >
                  <Globe size={16} className="md:w-5 md:h-5" />
                  Visit Website
                </a>
              )} */}
              {project.pypiUrl && (
                <a 
                  href={project.pypiUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-4 py-2 border-2 border-cyan-400 text-cyan-400 text-sm md:text-base hover:border-[#ff00ff] hover:text-[#ff00ff] transition-colors duration-300 rounded-lg"
                >
                  <Package size={16} className="md:w-5 md:h-5" />
                  View on PyPI
                </a>
              )}
            </div>
            
          </div>

          <div className="absolute top-0 left-0 w-3 h-3 md:w-4 md:h-4 border-t-2 border-l-2 border-cyan-400"></div>
          <div className="absolute top-0 right-0 w-3 h-3 md:w-4 md:h-4 border-t-2 border-r-2 border-cyan-400"></div>
          <div className="absolute bottom-0 left-0 w-3 h-3 md:w-4 md:h-4 border-b-2 border-l-2 border-cyan-400"></div>
          <div className="absolute bottom-0 right-0 w-3 h-3 md:w-4 md:h-4 border-b-2 border-r-2 border-cyan-400"></div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};
export default ProjectModal;
